import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import type { HTMLProps } from 'react';
import { CelebrityCard } from '@/components/molecules/CelebrityCard';
import type { Celebrity } from '@/entities/Celebrity/type/celebrities';
import { NoResults } from '@/entities/Experiences';
interface CelebritiesListProps extends HTMLProps<HTMLDivElement> {
  celebritiesList?: Celebrity[] | [];
  onSearch?: (value: string) => void;
}
const CelebritiesList = t0 => {
  const $ = _c(13);
  let celebritiesList;
  let className;
  let props;
  if ($[0] !== t0) {
    const {
      className: t1,
      celebritiesList: t2,
      onSearch,
      ...t3
    } = t0;
    className = t1;
    celebritiesList = t2;
    props = t3;
    $[0] = t0;
    $[1] = celebritiesList;
    $[2] = className;
    $[3] = props;
  } else {
    celebritiesList = $[1];
    className = $[2];
    props = $[3];
  }
  const locale = useLocale();
  if (celebritiesList?.length === 0 || !celebritiesList) {
    const t1 = `min-h-[314px] ${className}`;
    let t2;
    if ($[4] !== t1) {
      t2 = <div><NoResults className={t1} /></div>;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  const t1 = `grid grid-cols-2 gap-1.5 md:gap-2 lg:gap-4 md:grid-cols-3 lg:grid-cols-4 ${className}`;
  let t2;
  if ($[6] !== celebritiesList || $[7] !== locale) {
    t2 = celebritiesList?.length && celebritiesList.map(celebrity => <CelebrityCard href={`/${locale}/partners/${celebrity.id}-${`${celebrity.first_name} ${celebrity.last_name}`.trim().replace(/ /g, "-")}`} key={celebrity?.id} firstName={celebrity?.first_name} lastName={celebrity?.last_name} activitiesCount={celebrity?.activitiesCount} experiencesCount={celebrity?.experiencesCount} imageUrl={celebrity.main_screen_img} />);
    $[6] = celebritiesList;
    $[7] = locale;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t2) {
    t3 = <div className={t1} {...props}>{t2}</div>;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default CelebritiesList;